import { render, staticRenderFns } from "./StatementVersionsCellRenderer.vue?vue&type=template&id=4622fdb8"
import script from "./StatementVersionsCellRenderer.vue?vue&type=script&lang=js"
export * from "./StatementVersionsCellRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports